import dynamic from 'next/dynamic';
import { useRef } from 'react';
import FeatureBranch from '@/common/FeatureBranch';
import PageHeader from '@/common/PageHeader';
import { useFavorites, useIsLoggedIn } from '~/context/common/UserContext';
import { StaticSpinnerData } from '~/contracts/common';
import Hero from './Hero/Hero';
import { ImageCarousel } from './ImageCarousel';
import SpinnerSection from './Spinner/SpinnerSection';
import StickyBanner from './StickyBanner/StickyBanner';
import { ValueTracker } from './ValueTracker';
import { Vehicles } from './Vehicles';
import Video from './Video/Video';

const StickyCta = dynamic(
  () =>
    import(
      /* webpackChunkName: "StickyCta" */ '@/giveaway/StickyCta/StickyCta'
    ),
  { ssr: false }
);

type OwnProps = {
  spinnerData: StaticSpinnerData;
};

function Container({ spinnerData }: OwnProps) {
  const favorites = useFavorites();
  const isLoggedIn = useIsLoggedIn();

  const heroRef = useRef<HTMLElement>(null);

  return (
    <>
      <FeatureBranch appName="merchui" />
      <div className="bg-white">
        <PageHeader favorites={favorites} isLoggedIn={isLoggedIn} />
        <div className="max-w-[1800px] overflow-hidden">
          <StickyBanner heroRef={heroRef} />
          <Hero ref={heroRef} />
          <SpinnerSection image={spinnerData.spins[0].images.urls[8]} />
          <ImageCarousel spinnerData={spinnerData} />
          <Video />
          <Vehicles />
          <ValueTracker />
          <StickyCta />
        </div>
      </div>
    </>
  );
}

export default Container;
